import { render, staticRenderFns } from "./BsButton.vue?vue&type=template&id=677b67bf&scoped=true&"
import script from "./BsButton.vue?vue&type=script&lang=js&"
export * from "./BsButton.vue?vue&type=script&lang=js&"
import style0 from "./BsButton.vue?vue&type=style&index=0&id=677b67bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b67bf",
  null
  
)

export default component.exports